import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWebsiteBuilder, STEP_ROUTES } from './context/WebsiteBuilderContext';

export default function WebsiteBuilderIndexPage() {
  const navigate = useNavigate();
  const { currentStep, isOnboardingCompleted } = useWebsiteBuilder();

  useEffect(() => {
    // Wait until onboarding status is resolved
    if (isOnboardingCompleted === null) return;

    if (!isOnboardingCompleted) {
      navigate('/website-builder/onboarding', { replace: true });
    } else {
      navigate(STEP_ROUTES[currentStep] || '/website-builder/sitemap', { replace: true });
    }
  }, [isOnboardingCompleted, currentStep, navigate]);

  // Show a clean loading spinner while checking onboarding status
  if (isOnboardingCompleted === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="w-8 h-8 border-3 border-teal-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return null;
}
